import React, {useEffect, useState} from 'react';
import Wrapper from "../components/Wrapper.js";
import {useParams} from "react-router-dom";
import {Link} from "react-router";
import {word} from '../word.js';
import Api from "../Api.js";
import StaffItem from "../components/StaffItem.js";
import AddManager from "../components/AddManager.js";
import { ClipLoader } from "react-spinners";
import {useSelector} from "react-redux";

function Staff() {
    const {type} = useParams();  // Get type from URL
    const [show, setShow] = useState(false);
    const [staff, setStaff] = useState(null);
    const [manager, setManager] = useState(null);
    const [loader, setLoader] = useState(true);
    const login = useSelector((state) => state.manager.employee);

    const getData = async (type) => {
        try {
            const {data} = await Api.getStuffByType(type, 1000)
            setStaff(data.results)
            const manager = await Api.getStuffManagerByType(type)
            setManager(manager.data.results)
            setLoader(false);

        } catch (e) {
            setLoader(false);

        }
    }

    useEffect(() => {
        (async () => {
            await getData(type)
        })()
    }, [type]); // Re-fetch data when `type` changes

    return (
        <Wrapper>
            <div className='manager-stuff'>

                <div className='plus-cont' onClick={() => setShow(true)}>
                    <span className="plus">+</span>
                    <span className="tooltiptext">{word.addItem}</span>
                </div>

                {loader ? (
                    <div className="loaderMargin">
                        <ClipLoader type="Oval" color="#101C2A" size={30} />
                    </div>
                ) : (
                    <>
                        <div className='manager-stuff-list'>
                            {manager?.map((item, index) => (
                                <Link to={`/main_employee/staff/${type}/${item.id}/?manager=true`} key={index}>
                                    <StaffItem
                                        name={item?.user?.first_name}
                                        surname={item?.user?.last_name}
                                        image={item?.image}
                                        profession={item?.profession !== "null" ? item?.profession : ""}
                                    />
                                </Link>
                            ))}
                        </div>
                        <hr/>
                        <div className='manager-stuff-list'>
                            {staff?.filter(el => el.user.is_active).map((item, index) => (
                                <Link to={`/main_employee/staff/${type}/${item?.id}`} key={index}>
                                    <StaffItem
                                        getData={() => getData(type)}
                                        id={item.id}
                                        name={item?.user?.first_name}
                                        surname={item?.user?.last_name}
                                        image={item?.image}
                                        profession={item?.profession !== "null" ? item?.profession : ""}
                                    />
                                </Link>
                            ))}
                        </div>
                    </>
                )}
            </div>
            {show?<AddManager setData={setStaff} show={show} onHide={() => setShow(false)}/>:null}
        </Wrapper>
    );
}

export default Staff;